<template>
  <NuxtLayout name="error">
    <div class="bg-surface-primary flex flex-col justify-center items-center">
      <template v-if="error?.statusCode === 404">
        <ErrorPage404Banner />
        <div class="flex flex-col max-w-screen-md px-16 mt-32">
          <p>
            Vi vill ju att du ska hitta det du söker hos oss. Nu kan det vara så
            att sidan inte bor där man tror eller att den gått och bytt namn.
            Sånt händer!
          </p>
        </div>
        <ErrorPageNavigation />
      </template>
      <template v-else>
        <ErrorPageGenericBanner />
        <div class="flex flex-col max-w-screen-md px-16 mt-32">
          <p>
            Något gick lite struligt! Vänligen försök igen lite senare eller
            kontakta vår support så hjälper vi till med det, du kan chatta med
            oss
            <NuxtLink
              to="https://halebop.se/support"
              aria-label="här på supportsidan"
            >
              här.
            </NuxtLink>
          </p>
        </div>
        <ErrorPageNavigation />
      </template>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const error = useError();
</script>
<style scoped></style>
